import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

import Intro from 'components/UI/Programs/Intro'
import Base from 'components/Layout/Base'
import bgImage from 'images/bg-page-xperiential-expo.jpg'

const XperientialExpo = ({ location, data }) => {

    let dateString = `${ new Date(data.strapiProgram.StartDate).getDate() }${ data.strapiProgram.EndDate && data.strapiProgram.EndDate !== data.strapiProgram.StartDate ? ` - ${ new Date(data.strapiProgram.EndDate).getDate() }` : ''} ${ new Date(data.strapiProgram.StartDate).toLocaleString('default', { month: 'long' })  }`

    const Background = () => {
        return (<BackgroundContainer className="w-full h-full "></BackgroundContainer>)
    }

    return (
        <Base pageTitle={ data.strapiProgram.Title } background={<Background />}  location={ location } footerButtonColor="#9D1C8F" solidFooter={ true }>
            <Intro dateString={ dateString } logo={ data.strapiProgram.Logo.url } text={ data.strapiProgram.ShortDescription} />
        </Base>
    )
}

const BackgroundContainer = styled.div`
    background-image: url(${ bgImage });
    background-position: bottom-center;
    background-size: cover;
`

export const query = graphql`
    query XperientialExpo {
        strapiProgram(Title: {eq: "Xperiential Expo"}) {
            Logo {
                url
            }
            EndDate
            StartDate
            Title
            ShortDescription
        }
    }
`

export default XperientialExpo
